export type ServiceTypes = 'property' | 'destination' | 'search' | 'la_doc_service';

const DESTINATION_SERVICE_BASE_URL =
  process.env.NEXT_PUBLIC_API_BASE_URL_DESTINATION;
const SEARCH_SERVICE_BASE_URL =
  process.env.NEXT_PUBLIC_API_BASE_URL_SEARCH_SERVICE;
const PROPERTY_SERVICE_BASE_URL =
  process.env.NEXT_PUBLIC_API_BASE_URL_PROPERTY_SERVICE;
const LA_DOC_SERVICE_BASE_URL =
  process.env.NEXT_PUBLIC_API_BASE_URL_LA_DOC_SERVICE;

export function getAPIUrl(service: ServiceTypes, route: string): string {
  switch (service) {
    case 'property': {
      return `${PROPERTY_SERVICE_BASE_URL}${route}`;
    }
    case 'destination': {
      return `${DESTINATION_SERVICE_BASE_URL}${route}`;
    }
    case 'search': {
      return `${SEARCH_SERVICE_BASE_URL}${route}`;
    }
    case 'la_doc_service': {
      return `${LA_DOC_SERVICE_BASE_URL}${route}`;
    }
  }
}
